const Template = `<div>
<div  class="left-menu">
	<b-form-input class='input-dark' v-model="filter" :placeholder="$t('general.search')"></b-form-input>
  
<div  class="left-menu-table">

    <b-table
      id="tubes-table"
      :filter="filter"
      :items="tubes"
      :per-page="perPage"
      :current-page="currentPage"
      :fields="fields"
      :tbody-tr-class="rowClass"
      :filter-function="filterTable"
      striped
      borderless
      
      small
      hover
      dark
  		@row-clicked="tubeListClick"
    >
     	<template v-slot:cell(wire)="data">
       		{{ wireIcons(data.item) }} 
      	</template>
 	  	<template v-slot:cell(isol)="data">
        	<div class='isol-box'>
        		<div class='isol-inner-box' v-bind:style="isolStyle(data.item)">
                    <div>{{ data.item.tubeData.norm }}</div>
                </div>
        	</div>
        </template>
    </b-table>
  </div>

      <b-pagination
      v-model="currentPage"
      :total-rows="menuRows"
      :per-page="perPage"
      aria-controls="tubes-table"
      first-text = "⏮"
      prev-text = "⏪"
      next-text = "⏩"
      last-text = "⏭"
    ></b-pagination>
  </div>    
</div>`

export { Template }


// WEBPACK FOOTER //
// ./src/app/js/components/page1_tubes/left_menu/template.js